import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
} from '@material-ui/core';

import { formatDistBase } from './../../../utils/info-moduli';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
        padding: '0px',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    minWidth: {
        minWidth: '100%',
    },
    red: {
        backgroundColor: '#d9534f52',
        paddingTop: '0px',
        paddingBottom: '0px',
        '&:hover': {
            backgroundColor: '#ca535085',
        },
    },
    green: {
        backgroundColor: '#00ff0024',
        paddingTop: '0px',
        paddingBottom: '0px',
        '&:hover': {
            backgroundColor: '#00c50069',
        },
    },
    divider: {
        borderTop: '1px solid #00000021'
    },
    sub: {
        marginLeft: '24px',
    },
});


class ModuliDistBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isReadOnly: false,
        };

        this.setupChange = this.setupChange.bind(this);
    }

    componentDidMount() {
        if (this.props.dist_base.DistintaBase === false)
            this.setState({ isReadOnly: true });
    }

    componentDidUpdate(propsPrecedenti) {
        //Se cambio profilo predefinito faccio in modo che in caso di attivazione di una checkbox padre le figlie non rimangano disattivate
        if (this.props.dist_base.DistintaBase !== propsPrecedenti.dist_base.DistintaBase) {
            if (this.props.dist_base.DistintaBase === true) this.setState({ isReadOnly: false });
            else this.setState({ isReadOnly: true });
        }
    }

    setupChange(keyName, newValue) {
        if (!this.props.isReadOnly) {
            if (keyName === "DistintaBase") {
                if (newValue === false) {   //metto a false tutte le checkbox figlie
                    this.props.handleChangeFieldModulo('DistBase', 'DistintaBase', newValue);
                    this.props.handleChangeFieldModulo('DistBase', 'Produzione', newValue);
                    if (this.props.tipologia === "Enterprise") this.props.handleChangeFieldModulo('DistBase', 'RilTempi', newValue);

                    this.setState({ isReadOnly: true });
                }
                else {
                    this.props.handleChangeFieldModulo('DistBase', 'DistintaBase', newValue);

                    this.setState({ isReadOnly: false });
                }
            }
            else {
                this.props.handleChangeFieldModulo('DistBase', keyName, newValue);
            }
        }

    }

    render() {
        const { classes, dist_base } = this.props;
        const { isReadOnly } = this.state;

        return (
            <List className={classes.root}>


                {
                    Object.keys(dist_base).map((keyName, i) => {
                        const labelId = `checkbox-list-label-${keyName}`;

                        return (
                            <ListItem className={`${dist_base[keyName] === true ? classes.green : classes.red} ${keyName !== 'DistintaBase' ? classes.divider : null}`}
                                key={keyName}
                                role={undefined}
                                dense
                                button
                                disabled={keyName === 'DistintaBase' ? false : isReadOnly}
                                onClick={e => { this.setupChange(keyName, !dist_base[keyName]) }}
                            >
                                <ListItemIcon className={keyName !== 'DistintaBase' ? classes.sub : null}>
                                    <Checkbox
                                        edge="start"
                                        checked={dist_base[keyName]}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={formatDistBase(keyName)} />
                            </ListItem>
                        );
                    })

                }

            </List>

        );

    }
}

ModuliDistBase.propTypes = {
    dist_base: PropTypes.shape({}).isRequired,
    handleChangeFieldModulo: PropTypes.func.isRequired,

    tipologia: PropTypes.string.isRequired,

    isReadOnly: PropTypes.bool.isRequired
};

export default withStyles(styles)(ModuliDistBase);